const AttorneyAgentQuery = (id) => {
    return `
    query {
      getAgentById(id: "${id}") {
        id
        group_id,
        form_id,
        user_id,
        agent_id,
        AgentFormData {
          new_profile_individual_agent_type_id
          new_profile_individual_agent_last_name
          new_profile_individual_agent_first_name
          new_profile_individual_agent_middle_name
          new_profile_individual_agent_address_1
          new_profile_individual_agent_address_2
          new_profile_individual_agent_city
          new_profile_individual_agent_state_id
          new_profile_individual_agent_zip
          new_profile_individual_agent_country_id
          new_profile_individual_agent_province
          new_profile_individual_agent_phone
          new_profile_individual_agent_phone_ext
          new_profile_individual_agent_email
          new_profile_individual_agent_bar_number
          new_profile_individual_agent_court_state_id
          new_profile_individual_agent_court_name
          new_profile_individual_agent_job_title
          new_profile_individual_agent_profile_name
          new_profile_individual_agent_firm_name
          new_profile_individual_agent_firm_fein

        }
      }
    }
    `
}

export default AttorneyAgentQuery